var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModeProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "project-mode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6364 2.17999C12.7937 2.17999 13.9036 2.63973 14.7219 3.45807C15.5403 4.27641 16 5.38632 16 6.54363V9.45272C16 10.61 15.5403 11.7199 14.7219 12.5383C13.9036 13.3566 12.7937 13.8164 11.6364 13.8164H4.36364C3.20633 13.8164 2.09642 13.3566 1.27808 12.5383C0.459739 11.7199 0 10.61 0 9.45272V6.54363C0 5.38632 0.459739 4.27641 1.27808 3.45807C2.09642 2.63973 3.20633 2.17999 4.36364 2.17999H11.6364ZM11.6364 3.63454H4.36364C3.61728 3.63454 2.89947 3.9214 2.35868 4.43579C1.81789 4.95018 1.4955 5.65275 1.45818 6.39817L1.45455 6.54363V9.45272C1.45454 10.1991 1.74141 10.9169 2.2558 11.4577C2.77019 11.9985 3.47276 12.3209 4.21818 12.3582L4.36364 12.3618H11.6364C12.3827 12.3618 13.1005 12.075 13.6413 11.5606C14.1821 11.0462 14.5045 10.3436 14.5418 9.59817L14.5455 9.45272V6.54363C14.5455 5.79727 14.2586 5.07946 13.7442 4.53868C13.2298 3.99789 12.5272 3.67549 11.7818 3.63817L11.6364 3.63454ZM6.54545 5.81636V7.2709H8V8.72545H6.54473L6.54545 10.18H5.09091L5.09018 8.72545H3.63636V7.2709H5.09091V5.81636H6.54545ZM12.3636 8.72545V10.18H10.9091V8.72545H12.3636ZM10.9091 5.81636V7.2709H9.45455V5.81636H10.9091Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeProject);
export default __webpack_public_path__ + "static/media/ModeProject.754a7320b5c7b618ea5b156572fd504c.svg";
export { ForwardRef as ReactComponent };